// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/atlassian/pipelines/agent/build/src/models/beneficiary';
import model_2 from '/opt/atlassian/pipelines/agent/build/src/models/global';
import model_3 from '/opt/atlassian/pipelines/agent/build/src/models/segment';
import model_4 from '/opt/atlassian/pipelines/agent/build/src/models/store';
import model_5 from '/opt/atlassian/pipelines/agent/build/src/models/user';
import model_6 from '/opt/atlassian/pipelines/agent/build/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'beneficiary', model: model_1 },
model_2: { namespace: 'global', model: model_2 },
model_3: { namespace: 'segment', model: model_3 },
model_4: { namespace: 'store', model: model_4 },
model_5: { namespace: 'user', model: model_5 },
model_6: { namespace: '@@initialState', model: model_6 },
} as const
